import { List, ListItem } from '@/comps/list';
import { cn } from '@/utils/shad';
import {
  getValueComparatorLabel,
  VALUE_COMPARATOR_KINDS,
  ValueComparatorKind,
} from '@/comps/FilterPicker/filter-content-v2/interactionSpecialFilterAdapter';

type Props = {
  selectedKind: ValueComparatorKind | null;
  onSelectKind: (kind: ValueComparatorKind) => void;
};

export function FilterContentV2InteractionSpecialKindDropdown({ selectedKind, onSelectKind }: Props) {
  return (
    <div className="bg-[#09090B] p-1 shadow-md">
      <List className="z-50 flex w-auto flex-col gap-0.5">
        {VALUE_COMPARATOR_KINDS.map((kind) => (
          <ListItem
            key={kind}
            className={cn(
              'flex cursor-pointer items-center rounded-[8px] p-2 transition-colors hover:bg-neutral-800',
              selectedKind === kind && 'bg-neutral-800',
            )}
            onClick={() => onSelectKind(kind)}
          >
            <span className="text-xs text-foreground">{getValueComparatorLabel(kind)}</span>
          </ListItem>
        ))}
      </List>
    </div>
  );
}
